export default __webpack_public_path__ + "static/media/illustration-algostudy-m@2x.7d9aa0c1.webp";